import createMemoizedSelector from 'redux/selectors/createMemoizedSelector';
import { findImmuneModality } from 'const/enums/Modality';

// The immune modality (tcr or bcr), or undefined if there is no immune data
var getImmuneModality = function getImmuneModality() {
  return function (state) {
    var _state$info$modalitie;
    return findImmuneModality((_state$info$modalitie = state.info.modalities) !== null && _state$info$modalitie !== void 0 ? _state$info$modalitie : []);
  };
};
export default createMemoizedSelector(getImmuneModality);